<template>
  <div class="container py-5 mb-5">
    <replay2d/>
  </div>
</template>

<script>
import replay2d from '@/views/_cp_busi/replay_2d.vue'

export default {
  name: 'raceItem',
  components: {
    replay2d,
  },
  props: [],
  data() {
    return {
      cfg_max_num_raced: 1500,
    }
  },
  computed: {},
  watch: {},
  methods: {
    
  },
  created() {
    return
  },
  //mounted() {},
  //beforeDestroy() {},
  //update() {},
  //activited() {},
  //beforeRouteUpdate() {},
  //filters: {},
};
</script>

<style lang="scss" scoped>
  
</style>